<template lang="pug">

    p.ui.info.message(v-if="value.length === 0")
        | Keine Jobs vorhanden

    table.ui.very.basic.fixed.table(v-else)

        thead

            tr
                th.six.wide Lieferant
                th Gültig bis
                th.one.wide(v-for='variant in variantModels')
                    | V{{ variant.number }}
                th.one.wide &nbsp;

        tbody
            tr(
                is='row'
                v-for='(jobModel, index) in value'
                v-bind:key='jobModel.id'
                v-bind:offer-models="findAllOfferModelsForJobModel(jobModel)"
                v-bind:supplier-model="findSupplierModelForJobModel(jobModel)"
                v-bind:variant-models="variantModels"
                v-on:delete="onDelete"
                v-bind:value='value[index]'
                v-on:input="onJobInput($event, index)"
            )

</template>

<script>
    import * as R from 'ramda'
    import Row from './jobs-table/Row.vue'

    //noinspection ReservedWordAsName
    export default {
        name: 'products-job-list-table',

        components: { Row },

        methods: {

            findAllOfferModelsForJobModel(jobModel) {
                return R.concat(
                    R.filter(R.propEq('job', jobModel.id), this.offerModels),
                    R.filter(R.is(Object), jobModel.offers)
                )
            },

            findSupplierModelForJobModel(jobModel) {
                return R.find(R.propEq('id', jobModel.supplier), this.supplierModels)
            },

            findVariantModelByOfferModel(offerModel) {
                return R.find(R.propEq('id', offerModel.variant), this.variantModels)
            },

            onDelete(job) {
                this.$emit('delete', job)
            },

            onJobInput(jobModel, index) {
                this.$emit('input', R.update(index, jobModel, this.value))
            }

        },

        props: {

            offerModels: {
                type: Array,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            },

            value: {
                type: Array,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

        },

    }

</script>
